import React from "react";
import { useAuth } from "../context/AuthContext";
import { CountdownInline } from "./Countdown";
import { Gift } from "lucide-react";

export const FreeBanner = () => {
  const { freeUntil, freePeriodActive } = useAuth();
  if (!freeUntil || !freePeriodActive) return null;
  return (
    <div className="bg-clay text-white" data-testid="free-banner">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-2.5 flex flex-col sm:flex-row items-center justify-center gap-x-3 gap-y-1 text-center text-xs sm:text-sm">
        <span className="inline-flex items-center gap-2 font-bold">
          <Gift size={15} className="shrink-0" /> Shabba Robo is FREE for everyone until 1 Jan 2027
        </span>
        <span className="hidden sm:inline opacity-50">·</span>
        <CountdownInline target={freeUntil} />
      </div>
    </div>
  );
};
